import { IsNotEmpty, IsString } from 'class-validator';

import BaseIvrNode, { EMPTY_ERROR_ID_MESSAGE } from 'src/models/Ivrs/Nodes/baseIvrNode';

export default class VerifyAuthCode extends BaseIvrNode {
  authCode: string;

  customerId: string;

  successNodeId: string;

  failureNodeId: string;

  @IsString()
  @IsNotEmpty({ message: EMPTY_ERROR_ID_MESSAGE })
  errorNodeId: string;

  timeout: number;
}
